module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.config.epost.enabled ? _vm.config.cssClassPrefix + 'epost-enabled' : '',
    attrs: {
      "id": "couponplatz"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.cards.length) ? _c('div', {
    class: _vm.config.cssClassPrefix + 'loading'
  }, [_c('img', {
    attrs: {
      "src": "https://couponplatz.de/img/couponplatz-logo.svg",
      "width": "250",
      "alt": "Logo: couponplatz.de"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.cards.length) ? _c('div', [_c('div', {
    class: _vm.config.cssClassPrefix + 'toolbar'
  }, [_c('div', {
    class: _vm.config.cssClassPrefix + 'total-coupon-count'
  }, [_vm._v("\n          Du hast\n          "), (_vm.totalCount() > 1) ? _c('span', {
    class: _vm.config.cssClassPrefix + 'total-coupon-amount'
  }, [_vm._v("\n            " + _vm._s(_vm.totalCount()) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.totalCount() === 0) ? _c('span', [_vm._v("noch keine")]) : _vm._e(), _vm._v(" "), (_vm.totalCount() === 1) ? _c('span', [_vm._v("einen")]) : _vm._e(), _vm._v("\n          Coupon"), (_vm.totalCount() !== 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v("\n          gesammelt.\n        ")]), _vm._v(" "), _c('div', {
    class: [_vm.config.cssClassPrefix + 'cart-savings', _vm.totalCount() < _vm.config.print.minNoOfCoupons ? _vm.config.cssClassPrefix + 'less-than-minimum' : '']
  }, [_c('span', {
    class: _vm.config.cssClassPrefix + 'cart-arrow',
    on: {
      "click": function($event) {
        _vm.showCart = !_vm.showCart
      }
    }
  }), _vm._v("\n          Du sparst " + _vm._s(_vm._f("formatDecimal")(_vm.totalSavingsValue())) + " €\n          "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showCart) ? _c('table', {
    class: [_vm.config.cssClassPrefix + 'cart']
  }, [(_vm.totalCount() === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Dein Warenkorb ist einsam. Und traurig. :-("), _c('br'), _vm._v("\n                  Bring ihm doch ein paar Couponfreunde zum Spielen vorbei!\n                ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cart.items), function(cartItem) {
    return _c('tr', {
      class: _vm.config.cssClassPrefix + 'cart-item'
    }, [_c('td', [_vm._v(_vm._s(cartItem.count))]), _vm._v(" "), _c('td', [_vm._v("x")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cartItem.name))]), _vm._v(" "), _c('td', {
      class: _vm.config.cssClassPrefix + 'tar'
    }, [_vm._v("\n                  " + _vm._s(_vm._f("formatDecimal")((cartItem.count * cartItem.facevalue / 100))) + " €\n                ")]), _vm._v(" "), _c('td', [_c('button', {
      class: _vm.config.cssClassPrefix + 'cart-item-remove',
      on: {
        "click": function($event) {
          _vm.remove(cartItem)
        }
      }
    }, [_vm._v("x")])])])
  }), _vm._v(" "), (_vm.totalCount() > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('hr')])]) : _vm._e(), _vm._v(" "), (_vm.totalCount() > 0) ? _c('tr', {
    class: _vm.config.cssClassPrefix + 'cart-item'
  }, [_c('td', [_vm._v(_vm._s(_vm.totalCount()))]), _vm._v(" "), _c('td', [_vm._v("x")]), _vm._v(" "), _c('td', [_vm._v("sparen =")]), _vm._v(" "), _c('td', {
    class: _vm.config.cssClassPrefix + 'tar'
  }, [_vm._v(_vm._s(_vm._f("formatDecimal")(_vm.totalSavingsValue())) + " €")]), _vm._v(" "), _c('td')]) : _vm._e()], 2) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.config.print.enabled || _vm.config.epost.enabled) ? _c('form', {
    class: _vm.config.cssClassPrefix + 'cart-form',
    attrs: {
      "action": _vm.config.print.actionUrl,
      "method": "post",
      "enctype": "application/x-www-form-urlencoded",
      "accept-charset": "UTF-8",
      "target": _vm.config.print.openInNewTab ? '_blank' : ''
    },
    on: {
      "submit": _vm.printCoupons
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartBase64),
      expression: "cartBase64"
    }],
    attrs: {
      "type": "hidden",
      "name": _vm.config.print.cartInputName,
      "id": "config.print.cartInputName"
    },
    domProps: {
      "value": (_vm.cartBase64)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cartBase64 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "filename",
      "id": "filename"
    },
    domProps: {
      "value": _vm.config.print.pdfFileName
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "forcedownload",
      "id": "forcedownload"
    },
    domProps: {
      "value": _vm.config.print.forceDownload
    }
  }), _vm._v(" "), (_vm.config.print.enabled) ? _c('button', {
    class: _vm.config.cssClassPrefix + 'cart-form-print',
    attrs: {
      "type": "submit",
      "title": "Coupons einfach ausdrucken und lossparen!"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.couponplatz.de/img/ausdrucken.svg",
      "alt": "Coupons ausdrucken"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.config.epost.enabled) ? _c('button', {
    class: _vm.config.cssClassPrefix + 'cart-form-epost',
    attrs: {
      "type": "button",
      "title": "Coupons zuschicken lassen",
      "enabled": _vm.config.epost.minNoOfCoupons <= _vm.totalCount()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.epostSend($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.couponplatz.de/img/epost.svg",
      "alt": "Coupons zuschicken lassen"
    }
  })]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.config.epost.enabled) ? _c('epost-form', {
    attrs: {
      "cart-base64": _vm.cart.getCartBase64(),
      "show-epost-form": _vm.showEpostForm
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    class: _vm.config.cssClassPrefix + 'cards'
  }, [_vm._l((_vm.cards), function(card) {
    return _c('li', {
      class: [_vm.activeCard.couponcode === card.couponcode ? 'couponplatz-card-is-active' : '', _vm.config.cssClassPrefix + 'card-container']
    }, [_c('div', {
      staticClass: "couponplatz-card",
      on: {
        "click": function($event) {
          _vm.toggleActive(card)
        }
      }
    }, [_c('img', {
      class: _vm.config.cssClassPrefix + 'brand-img',
      attrs: {
        "src": card.brand.url,
        "alt": card.brand.title
      }
    }), _vm._v(" "), _c('span', {
      class: _vm.config.cssClassPrefix + 'facevalue'
    }, [_c('small', [_vm._v("Coupon")]), _vm._v("\n              " + _vm._s(_vm._f("formatDecimal")(card.facevalue / 100)) + " €\n              "), _c('span', {
      class: _vm.config.cssClassPrefix + 'save-text'
    }, [_vm._v("Sparen")])]), _vm._v(" "), _c('span', {
      class: _vm.config.cssClassPrefix + 'coupon-expiry'
    }, [_vm._v("\n              Gültig bis " + _vm._s(_vm._f("formatDate")(card.expires)) + "\n            ")]), _vm._v(" "), _c('img', {
      class: _vm.config.cssClassPrefix + 'product-img',
      attrs: {
        "src": card.media.productshot_small,
        "alt": card.title
      }
    }), _vm._v(" "), _c('div', {
      class: _vm.config.cssClassPrefix + 'card-title'
    }, [_vm._v(_vm._s(card.title))]), _vm._v(" "), _c('div', {
      class: _vm.config.cssClassPrefix + 'coupon-amount-control'
    }, [_c('button', {
      class: _vm.config.cssClassPrefix + 'minus',
      attrs: {
        "disabled": !_vm.cardCount(card)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.decreaseCouponCount(card)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), (_vm.cardCount(card)) ? _c('span', {
      class: _vm.config.cssClassPrefix + 'card-count'
    }, [_vm._v(_vm._s(_vm.cardCount(card)))]) : _vm._e(), _vm._v(" "), (!_vm.cardCount(card)) ? _c('span', {
      class: _vm.config.cssClassPrefix + 'card-select',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.increaseCouponCount(card)
        }
      }
    }, [_vm._v("Auswählen")]) : _vm._e(), _vm._v(" "), _c('button', {
      class: _vm.config.cssClassPrefix + 'plus',
      attrs: {
        "disabled": _vm.totalCount() >= _vm.config.maxCouponCount,
        "title": _vm.totalCount() >= _vm.config.maxCouponCount ? 'Maximale Coupon-Anzahl erreicht' : 'Klicke hier, um einen ' + card.title.split(' ').join('-') + '-Coupon hinzuzufügen.'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.increaseCouponCount(card)
        }
      }
    }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
      class: _vm.config.cssClassPrefix + 'card-preview'
    }, [_c('img', {
      class: _vm.config.cssClassPrefix + 'brand-img',
      attrs: {
        "src": card.media.brand_small,
        "alt": card.brand.title
      }
    }), _vm._v(" "), _c('span', {
      class: _vm.config.cssClassPrefix + 'coupon-expiry'
    }, [_vm._v("\n              Gültig bis " + _vm._s(_vm._f("formatDate")(card.expires)) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(card.condition))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(card.disclaimer))]), _vm._v(" "), _c('img', {
      class: _vm.config.cssClassPrefix + 'product-img',
      attrs: {
        "src": card.media.productshot_small,
        "alt": card.title
      }
    }), _vm._v(" "), _c('div', {
      class: _vm.config.cssClassPrefix + 'card-title'
    }, [_vm._v(_vm._s(card.title))]), _vm._v(" "), _c('span', {
      class: _vm.config.cssClassPrefix + 'card-preview-close',
      on: {
        "click": function($event) {
          _vm.activeCard = {}
        }
      }
    })])])
  }), _vm._v(" "), (_vm.totalCount() >= _vm.config.maxCouponCount) ? _c('li', {
    class: _vm.config.cssClassPrefix + 'cards-overlay'
  }, [_c('div', {
    class: _vm.config.cssClassPrefix + 'cards-overlay-content'
  }, [_c('img', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "src": "//www.codestylers.de/couponplatz/couponplatz-logo.svg",
      "width": "250",
      "alt": "Logo: couponplatz.de"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Du hast die maximale Anzahl von " + _vm._s(_vm.config.maxCouponCount) + " Coupons erreicht.")])])]) : _vm._e()], 2)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b093ace8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/couponplatz.vue
// module id = 224
// module chunks = 0